import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';

import Canonical from 'Components/Utility/SEO/Canonical';
import { history } from 'Redux/store';
import { createBlogQueryParams } from 'Redux/ducks/blog';

const BlogPagination = ({ page, nbPages, tag, category, search, noResults, authorSlug }) => {
  const updateUrl = (pageParam) => {
    const params = createBlogQueryParams(search, tag, pageParam);

    if (category) {
      return history.push(`/blog/category/${category}?${params}`);
    }

    if (authorSlug) {
      return history.push(`/blog/authors/${authorSlug}?${params}`);
    }

    return history.push(`/blog?${params}`);
  };

  const changePage = (e) => {
    e.preventDefault();
    const value = e.target.getAttribute('value');
    if (value) {
      updateUrl(value);
    }
  };

  const createAnchor = (pageParam, i) => {
    let active = false;
    const pageNumber = i.page + 1;
    if (i) {
      active = (pageParam === i.page);
    }

    const prevPages = 1;
    let nextPages = 3;
    if (pageParam === 0) {
      nextPages = 4;
    }

    const params = createBlogQueryParams(search, tag, pageNumber);

    let urlParams = '';

    if (category) {
      urlParams = `/category/${category}?${params}`;
    }

    if (authorSlug) {
      urlParams = `/authors/${authorSlug}?${params}`;
    }

    urlParams = `?${params}`;

    return (
      <li
        key={i.page}
        className={classNames('page-item',
          { hidden: pageParam > (i.page + prevPages) },
          { hidden: pageParam < (i.page - nextPages) },
        )}
      >
        <a
          role="button"
          href={`${window.location.pathname}${urlParams}`}
          value={i.page + 1}
          className={classNames('page-link', { active })}
          onClick={changePage}
        >{i.page + 1}</a>
      </li>
    );
  };

  const getTotalPageNumbers = () => {
    const nbPagesArray = [];
    if (nbPages <= 1) {
      return false;
    }
    for (let i = 0; i < nbPages; i += 1) {
      nbPagesArray.push({ page: i });
    }

    return nbPagesArray.map(i => createAnchor(page, i));
  };

  const createRelAnchor = (direction, pageParm, aria) => {
    const params = createBlogQueryParams(search, tag, pageParm);

    let urlParams = '';

    if (category) {
      urlParams = `/category/${category}?${params}`;
    }

    urlParams = `?${params}`;

    return (
      <li className="page-item">
        <a
          href={`${window.location.pathname}${urlParams}`}
          value={pageParm}
          className="page-link"
          aria-label={direction}
          role="button"
          onClick={changePage}
        >
          <span aria-hidden="true">
            {aria === '\u203a' &&
              <FontAwesomeIcon icon={faChevronRight} title="Next" />
            }
            {aria === '\u2039' &&
              <FontAwesomeIcon icon={faChevronLeft} title="Previous" />
            }
          </span>
          <span className="sr-only">{direction}</span>
        </a>
      </li>
    );
  };


  const nextAnchor = createRelAnchor('Next', (page + 2), '\u203a');
  const previousAnchor = createRelAnchor('Previous', page, '\u2039');
  const params = createBlogQueryParams(search, tag);

  let urlParams = '';

  if (params) {
    urlParams = `?${params}`;
  }

  if (category) {
    urlParams = `/category/${category}`;
  }

  if (category && params) {
    urlParams = `/category/${category}?${params}`;
  }

  if (authorSlug) {
    urlParams = `/authors/${authorSlug}`;
  }

  if (authorSlug && params) {
    urlParams = `/authors/${authorSlug}?${params}`;
  }

  return (
    <div className="container">
      <Canonical
        displayRawUrl
        page={page}
        nbPages={nbPages}
        path={`blog${urlParams}`}
        noResults={noResults}
      />
      <Row className="d-flex justify-content-center">
        <nav aria-label="Page navigation" className="algoliaPaginate algoliaPaginate--light">
          <ul className="pagination">
            {(page + 1) !== 1 &&
              previousAnchor
            }

            {getTotalPageNumbers()}

            {nbPages >= (nbPages - 1) && (page + 1) !== (nbPages) &&
              nextAnchor
            }
          </ul>
        </nav>
      </Row>
    </div>
  );
};

BlogPagination.propTypes = {
  page: PropTypes.number.isRequired,
  nbPages: PropTypes.number.isRequired,
  tag: PropTypes.string,
  category: PropTypes.string,
  search: PropTypes.string,
  noResults: PropTypes.bool,
  authorSlug: PropTypes.string,
};

BlogPagination.defaultProps = {
  tag: '',
  category: '',
  search: '',
  noResults: false,
  authorSlug: '',
};

export default BlogPagination;
